export default {
  masterChef: {
    97: '0x1d32c2945C8FDCBc7156c553B7cEa4325a17f4f9',
    56: '0x73feaa1eE314F8c655E354234017bE2193C9E24E',
  },
  sousChef: {
    97: '0xd3af5fe61dbaf8f73149bfcfa9fb653ff096029a',
    56: '0x6ab8463a4185b80905e05a9ff80a2d6b714b9e95',
  },
  lotteryV2: {
    97: '0x5790c3534F30437641541a0FA04C992799602998',
    56: '0x5aF6D33DE2ccEC94efb1bDF8f92Bd58085432d2c',
  },
  multiCall: {
    56: '0xfF6FD90A470Aaa0c1B8A54681746b07AcdFedc9B',
    97: '0x8F3273Fb89B075b1645095ABaC6ed17B2d4Bc576',
  },
  pancakeProfile: {
    56: '0xDf4dBf6536201370F95e06A0F8a7a70fE40E388a',
    97: '0x4B683C7E13B6d5D7fd1FeA9530F451954c1A7c8A',
  },
  pancakeRabbits: {
    56: '0xDf7952B35f24aCF7fC0487D01c8d5690a60DBa07',
    97: '0x60935F36e4631F73f0f407e68642144e07aC7f5E',
  },
  bunnyFactory: {
    56: '0xfa249Caa1D16f75fa159F7DFBAc0cC5EaB48CeFf',
    97: '0x707CBF373175fdB601D34eeBF2Cf665d08f01148',
  },
  claimRefund: {
    56: '0xE7e53A7e9E3Cf6b840f167eF69519175c497e149',
    97: '',
  },
  pointCenterIfo: {
    56: '0x3C6919b132462C1FEc572c6300E83191f4F0012a',
    97: '0xd2Ac1B1728Bb1C11ae02AB6e75B76Ae41A2997e3',
  },
  bunnySpecial: {
    56: '0xFee8A195570a18461146F401d6033f5ab3380849',
    97: '0x7b7b1583De1DeB32Ce6605F6deEbF24A0671c17C',
  },
  tradingCompetition: {
    56: '0xd718baa0B1F4f70dcC8458154042120FFE0DEFFA',
    97: '0xC787F45B833721ED3aC46E99b703B3E1E01abb97',
  },
  tradingCompetitionV2: {
    56: '0xA8FECf847e28aa1Df39E995a45b7FCfb91b676d4',
    97: '',
  },
  easterNft: {
    56: '0x23c41D28A239dDCAABd1bb1deF8d057189510066',
    97: '0x24ec6962dbe874F6B67B5C50857565667fA0854F',
  },
  cakeVault: {
    56: '0xa80240Eb5d7E05d3F250cF000eEc0891d00b51CC',
    97: '',
  },
  ifoPool: {
    56: '0x1B2A2f6ed4A1401E8C73B4c2B6172455ce2f78E8',
    97: '',
  },
  predictions: {
    56: '0x18B2A687610328590Bc8F2e5fEdDe3b582A49cdA',
    97: '',
  },
  chainlinkOracle: {
    56: '0xD276fCF34D54A926773c399eBAa772C12ec394aC',
    97: '',
  },
  bunnySpecialCakeVault: {
    56: '0x5B4a770Abe7Eafb2601CA4dF9d73EA99363E60a4',
    97: '',
  },
  bunnySpecialPrediction: {
    56: '0x342c99e9aC24157657095eC69CB04b73257e7A9C',
    97: '',
  },
  bunnySpecialLottery: {
    56: '0x24ED31d31C5868e5a96aA77fdcB890f3511fa0b2',
    97: '0x382cB497110F398F0f152cae82821476AE51c9cF',
  },
  farmAuction: {
    56: '0xb92Ab7c1edcb273AbA24b0656cEb3681654805D2',
    97: '0x3F9602593b4f7C67ab045DB51BbDEa94E40fA9Fe',
  },
  AnniversaryAchievement: {
    56: '0x787980da5491118C3cB33B21aB50c8c379D2C552',
    97: '0x981aE96378e770DE44F89cD9175E708f9EDB70a9',
  },
  nftMarket: {
    56: '0x17539cCa21C7933Df5c980172d22659B8C345C5A',
    97: '0x7f9f37ddcaa33893f9beb3d8748c8d6bfbde6ab2',
  },
  nftSale: {
    56: '0x29fE7148636b7Ae0b1E53777b28dfbaA9327af8E',
    97: '0xe486De509c5381cbdBF3e71F57D7F1f7570f5c46',
  },
  pancakeSquad: {
    56: '0x0a8901b0E25DEb55A87524f0cC164E9644020EBA',
    97: '0xfC0c3F11fDA72Cb9A56F28Ec8D44C0ae4B3ABF86',
  },
  presale: {
    56: '',
    97: '',
    1: '',
    4: '0x997d877472d8fbdF293D87623Ce42930DcD14008',
    137: '',
    80001: '0x3efbc36543CA1C0a963767C6DFA0d1f5B4A5E427',
    250: '',
    43113: '0xCa4D373D70b02a9ED4937e0D79AF1afE2e8ECCc4', // avax testnet
    96: '',
  },
  pancakeRouter: {
    1: '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D',
    4: '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D',
    56: '0x10ed43c718714eb63d5aa57b78b54704e256024e',
    97: '0xD99D1c33F9fC3444f8101754aBC46c52416550D1',
    137: '0x1b02da8cb0d097eb8d57a175b88c7d8b47997506',
    80001: '0x1b02da8cb0d097eb8d57a175b88c7d8b47997506',
    250: '',
    43113: '0xCa4D373D70b02a9ED4937e0D79AF1afE2e8ECCc4', // avax testnet
    96: '',
  },
  occ: {
    56: '',
    97: '0x36741e2b3de165cc99Cef3D9EE570D172e4e47B5',
    1: '',
    4: '0x81D9857eC217CEf13c3c537088D774b61122FC3F',
    137: '',
    80001: '0x06E995e738d313DC4Bcc70f8f09A72816D9E3Ae6',
    250: '',
    43113: '0xCa4D373D70b02a9ED4937e0D79AF1afE2e8ECCc4', // avax testnet
    96: '',
  },
  payboltIdo: {
    56: '0x9F45951baBD39e1DB3796eEb6420540e8Dd073e1', // bsc
    97: '',
    1: '0x17EB063913c32234Ab4F72899144f05483A170a7', // eth
    4: '', // '0x187dCc47ef034b340B67A3617F6FDe1569a18Fb2', // rinkedby
    137: '0x9F45951baBD39e1DB3796eEb6420540e8Dd073e1', // polygon
    80001: '', // '0x3082252B5481A89df1cdf99577b85386AFF470D4', // mumbai
    250: '',
    43113: '0xCa4D373D70b02a9ED4937e0D79AF1afE2e8ECCc4',// avax testnet
    96: '',
  },
}
